import React, { useEffect, useState } from "react";
import "./BusFilter.css";
import { Col } from "react-bootstrap";
import { FaChevronDown, FaSearchLocation } from "react-icons/fa";
import Slider from "rc-slider";

const BusFilter = ({ busData, applyFilters, priceLimits }) => {
  const [isBoardingOpen, setIsBoardingOpen] = useState(true);
  const [isDroppingOpen, setIsDroppingOpen] = useState(true);
  const [isBusOperatorOpen, setIsBusOperatorOpen] = useState(true);
  const [isBusTypeOpen, setIsBusTypeOpen] = useState(true);

  // extracted filter options
  const [boardingPoints, setBoardingPoints] = useState([]);
  const [droppingPoints, setDroppingPoints] = useState([]);
  const [busOperators, setBusOperators] = useState([]);
  const [busTypes, setBusTypes] = useState([]);

  // selected filters
  const [selectedPrice, setSelectedPrice] = useState(priceLimits);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedOperators, setSelectedOperators] = useState([]);
  const [selectedBoarding, setSelectedBoarding] = useState([]);
  const [selectedDropping, setSelectedDropping] = useState([]);

  const [selectedSeatTypes, setSelectedSeatTypes] = useState([]);

const toggleSeatType = (type) => {
  setSelectedSeatTypes((prev) =>
    prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
  );
};

const [selectedDepartureSlots, setSelectedDepartureSlots] = useState([]);

const toggleDepartureSlot = (slot) => {
  setSelectedDepartureSlots((prev) =>
    prev.includes(slot) ? prev.filter((s) => s !== slot) : [...prev, slot]
  );
};



  // --- Extract filter data dynamically from API ---
  useEffect(() => {
    if (!busData?.length) return;

    // boarding points
    const bPoints = [
      ...new Set(
        busData.flatMap(
          (bus) =>
            bus.BoardingPointsDetails?.map((bp) => bp.CityPointName) || []
        )
      ),
    ];
    setBoardingPoints(bPoints);

    // dropping points
    const dPoints = [
      ...new Set(
        busData.flatMap(
          (bus) =>
            bus.DroppingPointsDetails?.map((dp) => dp.CityPointName) || []
        )
      ),
    ];
    setDroppingPoints(dPoints);

    // operators
    const operators = [...new Set(busData.map((bus) => bus.TravelName))];
    setBusOperators(operators);

    // bus types (extract AC / Non-AC only)
    const types = [
      ...new Set(
        busData.map((bus) =>
          bus.BusType?.toLowerCase().includes("a/c") ? "AC" : "Non-AC"
        )
      ),
    ];
    setBusTypes(types);


    // reset selections when new data comes
    setSelectedPrice(priceLimits);
    setSelectedTypes([]);
    setSelectedOperators([]);
    setSelectedBoarding([]);
    setSelectedDropping([]);
  }, [busData, priceLimits]);

  // --- Apply filters whenever selection changes ---
useEffect(() => {
  applyFilters(
    selectedPrice,
    selectedTypes,
    selectedOperators,
    selectedBoarding,
    selectedDropping,
    selectedDepartureSlots,   
    selectedSeatTypes         
  );
}, [
  selectedPrice,
  selectedTypes,
  selectedOperators,
  selectedBoarding,
  selectedDropping,
  selectedDepartureSlots,
  selectedSeatTypes
]);


  // checkbox handler
  const handleCheckboxChange = (value, setter, prev) => {
    if (prev.includes(value)) {
      setter(prev.filter((v) => v !== value));
    } else {
      setter([...prev, value]);
    }
  };

  // clear all
  const handleClearAll = () => {
    setSelectedPrice(priceLimits);
    setSelectedTypes([]);
    setSelectedOperators([]);
    setSelectedBoarding([]);
    setSelectedDropping([]);
    applyFilters(priceLimits, [], [], [], []);
  };

  return (
    <Col
      className="filterDiv flightListPage busFilterDiv"
      style={{ marginBottom: "15px" }}
    >
      <div className="filterHead">
        <p
          style={{
            fontWeight: "600",
            color: "#001f5d",
            fontSize: "18px",
            margin: "5px",
          }}
        >
          FILTER
        </p>
        <p style={{ margin: "5px", cursor: "pointer" }} onClick={handleClearAll}>
          CLEAR ALL
        </p>
      </div>

      {/* Price Range */}
      <div className="filterDivs">
        <div className="filterSubDiv">
          <p>Price Range</p>
        </div>
        <div className="box-content">
          <Slider
            range
            min={priceLimits[0]}
            max={priceLimits[1]}
            value={selectedPrice}
            onChange={setSelectedPrice}
            className="custom-slider"
          />
          <div className="slider-value">
            <span>₹{selectedPrice[0]}</span> - <span>₹{selectedPrice[1]}</span>
          </div>
        </div>
      </div>

{/* Departure Time */}
<div className="filterDivs" style={{ minHeight: "150px" }}>
  <div className="filterSubDiv">
    <p>Departure time</p>
  </div>
  <div className="prc_val ft1-sec">
    <div className="tm-dt1">

      <div className="tm11">
        <div
          className={`tm-m11 ${selectedDepartureSlots.includes("before6") ? "active-departure" : ""}`}
          onClick={() => toggleDepartureSlot("before6")}
        >
          <div className="mor-n1"></div>
          <div className="tm-nf1 twh-bus">Before<br />6 AM</div>
        </div>
      </div>

      <div className="tm22">
        <div
          className={`tm-m12 ${selectedDepartureSlots.includes("6to12") ? "active-departure" : ""}`}
          onClick={() => toggleDepartureSlot("6to12")}
        >
          <div className="mor1-n2"></div>
          <div className="tm-nf2">6 AM -<br />12 PM</div>
        </div>
      </div>

      <div className="tm33">
        <div
          className={`tm-m22 ${selectedDepartureSlots.includes("12to18") ? "active-departure" : ""}`}
          onClick={() => toggleDepartureSlot("12to18")}
        >
          <div className="mor2-n3"></div>
          <div className="tm-nf3">12 PM -<br />6 PM</div>
        </div>
      </div>

      <div className="tm11-n">
        <div
          className={`tm-m33 ${selectedDepartureSlots.includes("after18") ? "active-departure" : ""}`}
          onClick={() => toggleDepartureSlot("after18")}
        >
          <div className="mor3-n4"></div>
          <div className="tm-nf4">After<br />6 PM</div>
        </div>
      </div>

    </div>
  </div>
</div>

{/* Seat Type */}
<div className="filterDivs busFilter-seatType" style={{ minHeight: "150px" }}>
  <div className="filterSubDiv">
    <p>Seat Type</p>
  </div>
  <div className="prc_val ft1-sec2 busFilter-seatType">
    <div className="busFilter-Seats">

      <div className="busFilter-Seats1">
        <div
          className={`busFilter-seatSleeper ${selectedSeatTypes.includes("Sleeper") ? "active-seatType" : ""}`}
          onClick={() => toggleSeatType("Sleeper")}
        >
          <div><img src="/Images/buses/sleeping.png" alt="" /></div>
          <div className="busFilter-Sleeper">Sleeper</div>
        </div>
      </div>

      <div className="busFilter-Seats1">
        <div
          className={`busFilter-seatSleeper ${selectedSeatTypes.includes("Seater") ? "active-seatType" : ""}`}
          onClick={() => toggleSeatType("Seater")}
        >
          <div><img src="/Images/buses/seat.png" alt="" /></div>
          <div className="busFilter-Sleeper">Seater</div>
        </div>
      </div>

    </div>
  </div>
</div>

{/* Bus Types */}
<div className="filterDivs busFilter-seatType" style={{ minHeight: "150px" }}>
  <div className="filterSubDiv">
    <p>Bus Types</p>
  </div>
  <div className="prc_val ft1-sec2 busFilter-seatType">
    <div className="busFilter-Seats">
      {busTypes.map((type, i) => (
        <div key={i} className="busFilter-Seats1">
          <div
            className={`busFilter-seatSleeper ${
              selectedTypes.includes(type) ? "active-seatType" : ""
            }`}
            onClick={() =>
              setSelectedTypes((prev) =>
                prev.includes(type)
                  ? prev.filter((t) => t !== type)
                  : [...prev, type]
              )
            }
          >
            <div>
              <img
                src={type === "AC" ? "/Images/buses/air-conditioner.png" : "/Images/buses/air-conditioning.png"}
                alt={type}
              />
            </div>
            <div className="busFilter-Sleeper">{type}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


      {/* Boarding Points */}
      <div className="Buslisting-boardingPointsWrap">
        <div className="Buslisting-boardingPointsHeader">
          <h4>Boarding Points</h4>
          <span onClick={() => setIsBoardingOpen(!isBoardingOpen)}>
            <FaChevronDown />
          </span>
        </div>
        {isBoardingOpen && (
          <div className="Buslisting-boardingPointsList">
            {boardingPoints.map((point, i) => (
              <label key={i} className="Buslisting-boardingPointItem">
                <input
                  type="checkbox"
                  checked={selectedBoarding.includes(point)}
                  onChange={() =>
                    handleCheckboxChange(
                      point,
                      setSelectedBoarding,
                      selectedBoarding
                    )
                  }
                />{" "}
                {point}
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Dropping Points */}
      <div className="Buslisting-boardingPointsWrap">
        <div className="Buslisting-boardingPointsHeader">
          <h4>Dropping Points</h4>
          <span onClick={() => setIsDroppingOpen(!isDroppingOpen)}>
            <FaChevronDown />
          </span>
        </div>
        {isDroppingOpen && (
          <div className="Buslisting-boardingPointsList">
            {droppingPoints.map((point, i) => (
              <label key={i} className="Buslisting-boardingPointItem">
                <input
                  type="checkbox"
                  checked={selectedDropping.includes(point)}
                  onChange={() =>
                    handleCheckboxChange(
                      point,
                      setSelectedDropping,
                      selectedDropping
                    )
                  }
                />{" "}
                {point}
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Bus Operators */}
      <div className="Buslisting-boardingPointsWrap">
        <div className="Buslisting-boardingPointsHeader">
          <h4>Bus Operators</h4>
          <span onClick={() => setIsBusOperatorOpen(!isBusOperatorOpen)}>
            <FaChevronDown />
          </span>
        </div>
        {isBusOperatorOpen && (
          <div className="Buslisting-boardingPointsList">
            {busOperators.map((op, i) => (
              <label key={i} className="Buslisting-boardingPointItem">
                <input
                  type="checkbox"
                  checked={selectedOperators.includes(op)}
                  onChange={() =>
                    handleCheckboxChange(
                      op,
                      setSelectedOperators,
                      selectedOperators
                    )
                  }
                />{" "}
                {op}
              </label>
            ))}
          </div>
        )}
      </div>
    </Col>
  );
};

export default BusFilter;
